import {createSelector} from '@reduxjs/toolkit';

import {ApplicationStoreType} from 'desktop/store';

import {CompleteOrderType} from '../../../../../../types/completeOrderType';

import {MODULE_KEY_CHECKOUT} from '../constants';
import {getSavePaymentDataIsLoading, getStatusOfLoadingSaveOrder} from '../paymentStep/paymentStep';

/**
 * Get side review checkout
 * @param {ApplicationStoreType} store - current store
 * @return {CompleteOrderType} result
 */
export const getEntireCheckout = (store: ApplicationStoreType) => store[MODULE_KEY_CHECKOUT];

/**
 * Get result of complete order request
 * @param {ApplicationStoreType} store - current store
 * @return {CompleteOrderType} result
 */
export const getCompleteOrderResult = (store: ApplicationStoreType): CompleteOrderType =>
    store[MODULE_KEY_CHECKOUT].completeOrder;

/**
 * Get errors of complete order request
 * @param {ApplicationStoreType} store - current store
 * @return {Array<OrderErrorType>|undefined} errors
 */
export const getCompleteOrderErrors = createSelector(
    getCompleteOrderResult,
    completeOrder => completeOrder.errors,
);

/**
 * Get first error of complete order request
 * @param {ApplicationStoreType} store - current store
 * @return {Array<OrderErrorType>|undefined} errors
 */
export const getCompleteOrderFirstError = createSelector(
    getCompleteOrderResult,
    completeOrder => completeOrder?.errors?.[0]?.title || '',
);

/**
 * Get first error of complete order request
 * @param {ApplicationStoreType} store - current store
 * @return {Array<OrderErrorType>|undefined} errors
 */
export const getCompleteOrderFirstErrorCode = createSelector(
    getCompleteOrderResult,
    completeOrder => completeOrder?.errors?.[0]?.code || '',
);

/**
 * Get status of order complete placing
 * @param {ApplicationStoreType} store - current store
 * @return {boolean} status
 */
export const getIsCompleteOrderPlacing = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_CHECKOUT].completeOrder.status === 'pending';

/**
 * Get status of placing order
 */
export const getIsPlacingOrder = createSelector(
    getIsCompleteOrderPlacing,
    getStatusOfLoadingSaveOrder,
    getSavePaymentDataIsLoading,
    (isOrderPlacing, isSaveOrder, isPaymentDataLoading) =>
        isOrderPlacing || isSaveOrder || isPaymentDataLoading,
);
